import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';

export function paramDefault() {
    let url = 'expenseAccount/paramDefault?' + objectToQueryString({ userCode: UserCode(), employeeId: EmployeeId(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let paramDefault = response.param;

                //saveExpenseAccountCodes(expenseAccountCodes);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

function saveExpenseAccountParamDefault(config) {
    localStorage.setItem('expenseAccountParamDefault', JSON.stringify(config));
}